<p-fieldset class="title-legend" [legend]="legend">
    <div class="formgrid grid m-0 p-fluid">
        <div class="field col">
            <p-autoComplete [(ngModel)]="servicoSelecionado" [lazy]="true" [delay]="1000" [suggestions]="comboOutrosServicosFiltrado" (completeMethod)="filterAutoComplete($event)" field="descricao" [style]="{'min-width':'100%'}" [styleClass]="'p-inputtext-sm'" [placeholder]="'Digite para pesquisar...'">
                <ng-template let-produto pTemplate="item">
                    <div class="formgrid grid m-0 p-fluid">
                        <div class="field col-12 lg:col-3 text-sm">
                            <span class="titulo">Código</span>
                            <span>{{produto.cod_produto}}</span>
                        </div>
                        <div class="field col card-text">
                            <span class="titulo">Descrição</span>
                            <span>{{produto.descricao}}</span>
                        </div>
                    </div>
                    <div class="formgrid grid m-0 p-fluid">
                        <div class="field col-12 lg:col-3 text-sm">
                            <span class="titulo">Vlr Venda</span>
                            <span>{{produto.vlr_venda_tratado | currency: 'BRL' }}</span>
                        </div>
                        <div class="field col text-sm">
                            <span class="titulo">Perc Desconto</span>
                            <span>{{produto.desc_acresc_porcentagem | number: '1.1-2' }} %</span>
                        </div>
                        <div class="field col text-sm">
                            <span class="titulo">Vlr Liquido</span>
                            <span>{{produto.vlr_liquido_produto | currency: 'BRL' }}</span>
                        </div>
                    </div>
                </ng-template>
            </p-autoComplete>
        </div>

        <div class="field col-1 lg:col-2">
            <input type="text"
                class="p-inputtext p-component p-inputtext-sm w-full"
                [(ngModel)]="quantidadeAddStr"
                (blur)="onQuantidadeBlur()"
                style="text-align: right;">
        </div>

        <div class="field col-1">
            <p-button icon="pi pi-plus" [rounded]="true" [text]="true" severity="info " (click)="adicionarServico();"></p-button>
        </div>
    </div>
</p-fieldset>